import { InputLabel, MenuItem } from '@mui/material';
import { AxiosResponse } from 'axios';
import { memo } from 'react';
import { __ANPR_PERSON_NEW_API_URL__ } from 'shell/constants/environment';
import { useHttpFetch } from 'shell/hooks/use-http-fetch';
import { HttpResponseListPayloadQuarkus } from 'shell/models/http-response';
import { ItemVM } from 'shell/view-models/item';
import { PmiSelect } from '../pmi-select';
import { PmiFormControl } from '../pmi-select/pmi-form-control';

interface CohabitationBondListComponentProps {
  disabled?: boolean;
  value: string;
  onChange: (cohabitationBond?: string) => void;
  error?: boolean;
  label?: string;
  id?: string;
}

type Key = {
  codice: string;
};

interface CohabitationBond {
  key: Key;
  descrizione: string;
}

const CohabitationBondListComponent = ({
  disabled,
  onChange,
  value,
  error,
  label = 'Legame convivenza',
  id = 'cohabitationBond',
}: CohabitationBondListComponentProps): React.ReactElement => {
  const [cohabitationBond] = useHttpFetch<
    HttpResponseListPayloadQuarkus<CohabitationBond>,
    Array<ItemVM>
  >(`${__ANPR_PERSON_NEW_API_URL__}/legame-convivenza`, {
    onBootstrap: true,
    transformer: (response: AxiosResponse<HttpResponseListPayloadQuarkus<CohabitationBond>>) => {
      const { data } = response;

      return data?.payload.map((item) => ({
        id: item.key.codice,
        value: item.descrizione,
      })) as Array<ItemVM>;
    },
  });

  const list = (cohabitationBond.data as Array<ItemVM>) || [];

  const idTag = `${id}-${label}`;

  return (
    <PmiFormControl fullWidth>
      <InputLabel error={error} disabled={disabled} id={idTag}>
        {label || undefined}
      </InputLabel>
      <PmiSelect
        labelId={idTag}
        id={id}
        name={id}
        value={value}
        label={label || undefined}
        onChange={(event) => {
          const selectedValue = event.target.value;
          onChange(selectedValue);
        }}
        disabled={disabled}
        error={error}
      >
        <MenuItem value="">
          <em>Nessuno</em>
        </MenuItem>
        {list.map((item: ItemVM) => (
          <MenuItem key={item.id} value={item.id}>
            {item.value}
          </MenuItem>
        ))}
      </PmiSelect>
    </PmiFormControl>
  );
};

CohabitationBondListComponent.displayName = 'Cohabitation Bond List component';

const CohabitationBondList = memo(CohabitationBondListComponent);

export default CohabitationBondList as typeof CohabitationBondListComponent;
